import isEmpty from 'lodash/isEmpty';
import { useAppendDraftComment } from 'pages/WellGuardian/WIR/hooks';
import { getEngineeringWorkReactiveScopeData } from 'pages/WellGuardian/WIR/utils';
import { WIREngineeringWorkSections } from 'pages/WellGuardian/WIR/wir.constants';
import { useCallback, useMemo } from 'react';
import { useCountryState, useSelectedWIR } from '../../../../redux/WellGuardian/selectors';
import wellGuardianApiClient from 'services/networking/wellGuardianApiClient';
import { WIR } from 'types/wellGuardian';

export const useSectionEngineeringAnalysisData = () => {
  const wirFromState = useSelectedWIR();
  const { appendDraftComment } = useAppendDraftComment();
  const countryState = useCountryState();

  const assignEngineeringAnalysisPayload = useMemo(() => {
    const { phase, engineeringAnalysis } = getEngineeringWorkReactiveScopeData(
      wirFromState,
      countryState,
    );
    const meetingDate = engineeringAnalysis?.meetingDate;
    const userNameEngAnalysis = engineeringAnalysis?.userNameEngAnalysis;
    const userIdEngAnalysis = engineeringAnalysis?.userIdEngAnalysis;
    const engAnalysisAttendees = engineeringAnalysis?.engAnalysisAttendees;
    const comments = appendDraftComment(engineeringAnalysis?.comments || []);
    const sectionCompleteConfirmation = engineeringAnalysis?.sectionCompleteConfirmation;

    const isTicked = !isEmpty(userNameEngAnalysis) && !isEmpty(userIdEngAnalysis);

    return {
      meetingDate,
      userNameEngAnalysis,
      userIdEngAnalysis,
      engAnalysisAttendees,
      isTicked,
      sectionCompleteConfirmation,
      comments,
      phase,
      lastUpdatedDate: new Date().toISOString(),
      assignedTo: engineeringAnalysis?.assignedTo || '',
    };
  }, [wirFromState, appendDraftComment, countryState]);

  const saveAssignEngineeringAnalysisSection = useCallback(
    async (section: string, processSaveResponse: (wirResponse: WIR | null) => void) => {
      if (wirFromState?.wirNumber && section === WIREngineeringWorkSections.engineeringAnalysis) {
        processSaveResponse(
          await wellGuardianApiClient.updateWIREngineeringAnalysisSection(
            wirFromState?.wirNumber,
            assignEngineeringAnalysisPayload,
            countryState,
          ),
        );
      }
    },
    [wirFromState, assignEngineeringAnalysisPayload, countryState],
  );

  return {
    saveAssignEngineeringAnalysisSection,
    assignEngineeringAnalysisPayload,
  };
};
